/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
import { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Grid, Icon, IconButton, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { VTextField, VForm, useVForm, VTextFieldData, AutoCompleteParceiro, IVFormErrors, AutoCompletePlanoDeContas, VFieldMoneyNumber2, VFieldMoneyNumber4dn, VFieldMoney4, AutoCompleteVendedor } from '../../../shared/forms';
import { LayoutBaseDePaginaNfe } from '../../../shared/layouts';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { DialogEntrada } from './DialogEntrada';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { MovimentoService } from '../../../shared/services/api/estoque/movimento/MovimentoService';
import { AutoCompleteOperacoes } from '../../../shared/forms/AutoCompleteOperacoes';
import { DialogFaturamento } from './DialogFaturamento';
import { EstoqueOperacoesService } from '../../../shared/services/api/estoque/estoqueOperacoes/EstoqueOperacoesService';
import { alpha } from '@mui/material/styles';
import { getAuth } from './../../../GlobalDecode';
import { FerramentasDeDetalheVenda, TelaBloqueioSalvando } from '../../../shared/components';
import { useBloqueioSalvamento } from '../../../shared/hooks';

interface IFormData {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  numero: string;
  idoperacao: string;
  emissao: string;
  dataoperacao: string;
  vprod: number;
  tipo: number
  desconto: number;
  total: number;
  acrescimo: number;
}
interface IFormDataGetById {
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  emissao: string;
  dataoperacao: string;
  vprod: number;
  desconto: number;
  faturado: boolean;
  total: number;
  acrescimo: number;
}
interface IitensEntradaDialog {
  iditens: string;
  idprodutos: string;
  idref: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  ean?: string;
  localizado?: string;
  original?: boolean;
  subtotal: number;
  desconto: number;
  voutros: number;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  descricao: string;
}
interface JwtPayload {
  idempresa: string;
  iduser: string;
  tipoimp: number;
  refs: boolean;
  img: string;
  decimais: number;
}
interface IItensids {
  iditens: string;
}
dayjs.extend(utc);
dayjs.extend(timezone);

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'faturado' | 'idmov' | 'dataoperacao' | 'tipo'>> = yup.object().shape({
  idparceiro: yup.string().required(),
  idplanoconta: yup.string().required(),
  idoperacao: yup.string().required(),
  numero: yup.string().required(),
  emissao: yup
    .string()
    .required('O campo é obrigatório')
    .test('valid-date', 'Selecione uma data válida', function (value) {
      if (!value) return false;

      const dateValue = dayjs(new Date(value));

      return dateValue.isValid();
    }),
  vprod: yup.number().required().moreThan(0),
  desconto: yup.number().required(),
  total: yup.number().required().moreThan(0),
  acrescimo: yup.number().required(),
});

export const DetalheDaEntrada: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const { isSaving, progress: saveProgress, iniciar: iniciarSalvamento, concluir: concluirSalvamento, cancelar: cancelarSalvamento } = useBloqueioSalvamento();
  const [open, setOpen] = useState(false);
  const [openFaturamento, setOpenFaturamento] = useState(false);
  const [statuss, setStatuss] = useState(false);
  const [iditens, setIditens] = useState('');
  const [iditem, setIditem] = useState('');
  const [rows, setRows] = useState<IitensEntradaDialog[]>([]);
  const [rowsids, setRowsids] = useState<IItensids[]>([]);
  const [dadositens, setDadositens] = useState<IitensEntradaDialog>();
  const guuid = uuidv4();
  const [faturamento, setFaturamento] = useState<boolean>();
  const [venda, setvenda] = useState<boolean>();
  const [cabecalho, setCabecalho] = useState<IFormData>();
  const [operacao, setOperacao] = useState<string>();
  const [dataoperacao, setdataOperacao] = useState<string>();
  const [tpag, setTpag] = useState<number>();
  const [openmsg, setOpenmsg] = useState(false);
  const [openConfirmFinalizar, setOpenConfirmFinalizar] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [dialogItens, setDialogItens] = useState<IitensEntradaDialog[]>([]);
  const [openConfirmItem, setOpenConfirmItem] = useState(false);
  const auth = getAuth();
  const iduser = auth?.iduser;
  const decimais = auth?.decimais ?? 2;
  const est = auth?.est ?? false;

  const tabelaItensRef = useRef<HTMLDivElement>(null);
  const [densidadeTabela, setDensidadeTabela] = useState({
    maxHeight: 360,
    rowPy: 1.2,
    rowFontSize: 0.8,
    headerPy: 1,
    headerFontSize: 0.75,
  });

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);

  };
  const handleDelete = () => {
    setOpenConfirm(true);
  };
  const handleDeleteItem = (idi: string) => {
    setOpenConfirmItem(true);
    setIditem(idi);
  };
  const handleConfirmDelete = () => {
    MovimentoService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
          navigate(`/entrada`);
        }
      });
  };
  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };
  const handleCancelDeleteItem = () => {
    setOpenConfirmItem(false);
  };
  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      MovimentoService.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            formRef.current?.setData(result);
            setRows(result.itens);
            setdataOperacao(result.dataoperacao);
            const vprod = result.vprod || 0;
            const desconto = result.desconto || 0;
            const acrescimo = result.acrescimo || 0;
            if (result.tipo !== 3 && result.caixa === "0" && result.contapagas === "0") {
              setStatuss(false);
            } else {
              setStatuss(true);
            }
            if (vprod > 0) {
              const percDesconto = Number(((desconto / vprod) * 100).toFixed(4));
              const percAcrescimo = Number(((acrescimo / vprod) * 100).toFixed(4));
              formRef.current?.setFieldValue('descontopercentual', percDesconto);
              formRef.current?.setFieldValue('acrescimopercentual', percAcrescimo);
            }
            EstoqueOperacoesService.getById(result.idoperacao)
              .then((result) => {
                if (result instanceof Error) {
                  setTms('error');
                  setMsg(result.message);
                  setOpenmsg(true);
                } else {
                  setFaturamento(result.faturamento);
                  setOperacao(result.descricao);
                  setTpag(result.tpag)
                }
              });
          }
        });
    } else {
      formRef.current?.setData({
        idparceiro: '',
        idplanoconta: '',
        idoperacao: '',
        emissao: dayjs().tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss'),
        numero: '',
        vprod: 0,
        desconto: 0,
        total: 0,
        acrescimo: 0,
        acrescimopercentual: 0,
        descontopercentual: 0,
      });
      setRows([]);
    }
  }, [id]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const tag = (event.target as HTMLElement).tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      if (event.key === 'F3') {
        event.preventDefault();
        if (statuss === false && !isLoading) {
          setIditens('novo');
          setOpen(true);
        }
      }

      if (event.key === 'F4') {
        event.preventDefault();
        setOpenConfirmFinalizar(true);
      }

      if (event.key === 'F10') {
        event.preventDefault();

        if (id === 'novo') {
          setMsg('Salve a entrada antes de imprimir');
          setTms('warning');
          setOpenmsg(true);
          return;
        }
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        navigate('/venda');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [id, statuss, isLoading]);

  useEffect(() => {
    const data = formRef.current?.getData();
    const vprod = Number(data?.vprod) || 0;
    const desconto = Number(data?.desconto) || 0;
    const acrescimo = Number(data?.acrescimo) || 0;
    const novoTotal = vprod - desconto + acrescimo;
    formRef.current?.setFieldValue('total', novoTotal);
    if (vprod > 0) {
      const percDesconto = Number(((desconto / vprod) * 100).toFixed(4));
      const percAcrescimo = Number(((acrescimo / vprod) * 100).toFixed(4));
      formRef.current?.setFieldValue('descontopercentual', percDesconto);
      formRef.current?.setFieldValue('acrescimopercentual', percAcrescimo);
    } else {
      formRef.current?.setFieldValue('descontopercentual', 0);
      formRef.current?.setFieldValue('acrescimopercentual', 0);
    }
  }, [rows]);
  useEffect(() => {
    recalcularTotais();
  }, [rows]);

  useEffect(() => {
    const ALTURA_LINHA_MAX = 40;
    const ALTURA_LINHA_MIN = 24;
    const ALTURA_CABECALHO = 40;
    const ALTURA_MINIMA_TABELA = 96;
    const MARGEM_INFERIOR = 16;

    const ajustarDensidadeTabela = () => {
      if (!tabelaItensRef.current) return;

      const topOffset = tabelaItensRef.current.getBoundingClientRect().top;
      const alturaDisponivel = Math.max(
        window.innerHeight - topOffset - MARGEM_INFERIOR,
        ALTURA_MINIMA_TABELA
      );

      const qtdLinhas = Math.max(rows.length, 1);
      const alturaPorLinha = (alturaDisponivel - ALTURA_CABECALHO) / qtdLinhas;
      const fator = Math.min(
        Math.max(alturaPorLinha / ALTURA_LINHA_MAX, ALTURA_LINHA_MIN / ALTURA_LINHA_MAX),
        1
      );

      setDensidadeTabela({
        maxHeight: alturaDisponivel,
        rowPy: Number((1.2 * fator).toFixed(2)),
        rowFontSize: Number((0.8 * fator).toFixed(2)),
        headerPy: Number((1 * fator).toFixed(2)),
        headerFontSize: Number((0.75 * Math.max(fator, 0.85)).toFixed(2)),
      });
    };

    ajustarDensidadeTabela();
    window.addEventListener('resize', ajustarDensidadeTabela);

    return () => {
      window.removeEventListener('resize', ajustarDensidadeTabela);
    };
  }, [rows.length]);

  const recalcularTotais = () => {
    const totalSum = rows.reduce((accumulator, currentItem) => accumulator + (currentItem.subtotal || 0), 0);
    const data = formRef.current?.getData();
    const percentualdesconto = Number(data?.descontopercentual || 0);
    const desconto = totalSum > 0 ? Number(((totalSum * percentualdesconto) / 100).toFixed(4)) : 0;
    const percentualAcrescimo = Number(data?.acrescimopercentual || 0);
    const acrescimo = totalSum > 0 ? Number(((totalSum * percentualAcrescimo) / 100).toFixed(4)) : 0;
    const novoTotal = totalSum - desconto + acrescimo;
    formRef.current?.setFieldValue('vprod', totalSum);
    formRef.current?.setFieldValue('total', novoTotal);
    if (totalSum > 0) {
      formRef.current?.setFieldValue('desconto', desconto);
      formRef.current?.setFieldValue('acrescimo', acrescimo);
    } else {
      formRef.current?.setFieldValue('desconto', 0);
      formRef.current?.setFieldValue('acrescimo', 0);
    }
  };
  const handleSave = (dados: IFormData & {
    descontopercentual?: number;
    acrescimopercentual?: number;
  }) => {
    if (!iniciarSalvamento()) return;

    const {
      descontopercentual,
      acrescimopercentual,

      ...dadosSemPercentual
    } = dados;
    const dadosAjustados = {
      ...dadosSemPercentual,
      emissao: dayjs(dadosSemPercentual.emissao).format('YYYY-MM-DD HH:mm:ss'),
    };

    formValidationSchema.validate(dadosAjustados, { abortEarly: false })
      .then((dadosValidados) => {
        let dadosComData: any;


        if (id === 'novo') {
          dadosComData = {
            ...dadosValidados,
            dataoperacao: dayjs().tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss'),
            idmov: guuid,
          };
        }
        else {
          dadosComData = {
            ...dadosValidados,
            dataoperacao: dataoperacao,
            idmov: id,
          };
        }

        setCabecalho({
          ...dadosComData,
          tipo: 1,
        });
        if (id === 'novo') {
          if (faturamento && tpag === 2) {
            cancelarSalvamento();
            setOpenFaturamento(true);
          } else {
            MovimentoService
              .create(dadosComData, rows, [])
              .then((result) => {
                setIsLoading(false);

                if (result instanceof Error) {
                  cancelarSalvamento();
                  setTms('error');
                  setMsg(result.message);
                  setOpenmsg(true);
                } else {
                  setTms('success');
                  setMsg('Entrada realizada com sucesso!');
                  setOpenmsg(true);
                  concluirSalvamento();
                  navigate(`/entrada/${dadosComData.idmov}`);
                }
              });
          }
        } else {
          if (faturamento && tpag === 2) {
            cancelarSalvamento();
            setOpenFaturamento(true);
          } else {
            MovimentoService
              .updateById(id, dadosComData, rows, rowsids, [])
              .then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  cancelarSalvamento();
                  setTms('error');
                  setMsg(result.message);
                  setOpenmsg(true);
                } else {
                  setTms('success');
                  setMsg('Alteração concluída com sucesso!');
                  setOpenmsg(true);
                  concluirSalvamento();
                  navigate(`/entrada/${id}`);
                }
              });
          }
        }
      })
      .catch((errors: yup.ValidationError) => {
        cancelarSalvamento();
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };
  const handleBuscarDados = (id: string) => {
    const foundItem = rows.find((listItem) => listItem.iditens === id);
    if (foundItem) {
      setDadositens(foundItem);
    }
  };
  const handleCloseFaturamento = (newValue?: string) => {
    setOpenFaturamento(false);
    setIsLoading(false);
    if (newValue !== undefined) {
      navigate(`/entrada/${newValue}`);
    }
  };
  const handleConfirmDialog = (itens: IitensEntradaDialog[]) => {
    setRows(itens);
    setDialogItens([]);
    setOpen(false);
  };

  const handlecpf = (cpfs: string | undefined) => {
    if (cpfs != null && cpfs !== '') {
      formRef.current?.setFieldValue('cpf', cpfs);
    } else {
      formRef.current?.setFieldValue('cpf', '');
    }
  };
  const handleDesconto = (valor: number | undefined) => {
    if (valor === undefined || isNaN(valor)) return;

    const data = formRef.current?.getData();
    const vprod = Number(data?.vprod) || 0;
    const acrescimo = Number(data?.acrescimo) || 0;
    formRef.current?.setFieldValue(
      'desconto',
      (valor)
    );

    const novoTotal = vprod - valor + acrescimo;

    formRef.current?.setFieldValue(
      'total',
      (novoTotal)
    );

    if (vprod > 0) {
      const porcentagem = (valor / vprod) * 100;

      formRef.current?.setFieldValue(
        'descontopercentual',
        Number(porcentagem.toFixed(decimais))
      );
    } else {
      formRef.current?.setFieldValue('descontopercentual', 0);
    }
  };
  const handleAcrescimo = (valor: number | undefined) => {
    if (valor === undefined || isNaN(valor)) return;

    const data = formRef.current?.getData();

    const vprod = Number(data?.vprod) || 0;
    const desconto = Number(data?.desconto) || 0;
    formRef.current?.setFieldValue(
      'acrescimo',
      (valor)
    );
    const novoTotal = vprod - desconto + valor;

    formRef.current?.setFieldValue(
      'total',
      (novoTotal)
    );

    if (vprod > 0) {
      const porcentagem = (valor / vprod) * 100;

      formRef.current?.setFieldValue(
        'acrescimopercentual',
        Number(porcentagem.toFixed(decimais))
      );
    } else {
      formRef.current?.setFieldValue('acrescimopercentual', 0);
    }
  };
  const parseNumero = (valor: unknown): number => {
    if (typeof valor === 'number') return valor;
    if (typeof valor !== 'string') return 0;

    let val = valor.trim();

    if (/,\d{1,4}$/.test(val)) {
      val = val.replace(/\./g, '').replace(',', '.');
    } else {
      val = val.replace(/[^\d.-]/g, '');
    }
    return Number(val) || 0;
  };
  const handlePercentualDesconto = (percentual: number) => {
    const percentNum = Number(percentual) || 0;

    formRef.current?.setFieldValue(
      'descontopercentual',
      Number(percentNum.toFixed(decimais))
    );
    const data = formRef.current?.getData();
    const vprod = parseNumero(data?.vprod);
    const acrescimo = parseNumero(data?.acrescimo);
    if (vprod > 0) {
      const valorDesconto = (vprod * percentNum) / 100;
      const novoTotal = vprod - valorDesconto + acrescimo;
      formRef.current?.setFieldValue(
        'desconto',
        (valorDesconto)
      );
      formRef.current?.setFieldValue(
        'total',
        (novoTotal)
      );
    } else {
      formRef.current?.setFieldValue('desconto', (0));
      formRef.current?.setFieldValue('total', (0));
    }
  };
  const handlePercentualAcrescimo = (percentual: number | undefined) => {
    const percentNum = Number(percentual) || 0;

    formRef.current?.setFieldValue(
      'acrescimopercentual',
      Number(percentNum.toFixed(decimais)) // 🔥 dinâmico
    );
    const data = formRef.current?.getData();
    const vprod = parseNumero(data?.vprod);
    const desconto = parseNumero(data?.desconto);
    if (vprod <= 0) {
      formRef.current?.setFieldValue('acrescimo', (0));
      formRef.current?.setFieldValue('total', (0));
      return;
    }
    const valorAcrescimo = (vprod * percentNum) / 100;
    const novoTotal = vprod + valorAcrescimo - desconto;
    formRef.current?.setFieldValue(
      'acrescimo',
      (valorAcrescimo)
    );

    formRef.current?.setFieldValue(
      'total',
      (novoTotal)
    );
  };
  const handleFaturamento = (faturamento: boolean | undefined) => {
    // `faturamento === false`, não só falsy: `undefined` é o autocomplete sendo limpo (X ou
    // seleção apagada), não uma operação escolhida sem faturamento — não deve disparar o
    // bloqueio nesse caso.
    if (faturamento === false) {
      setFaturamento(undefined);
      setTpag(undefined);
      setOperacao(undefined);
      // Zera o campo no formulário — o autocomplete registra 'idoperacao' via unform, então
      // setFieldValue(undefined) limpa a seleção exibida (mesmo padrão de reversão usado em
      // DetalheDeVenda.tsx pra operacaoAnterior).
      formRef.current?.setFieldValue('idoperacao', undefined);
      setTms('error');
      setMsg('Esta operação não tem faturamento e não pode ser usada numa entrada. Escolha uma operação com faturamento ou ajuste o estoque no cadastro do produto.');
      setOpenmsg(true);
      return;
    }
    setFaturamento(faturamento);
  };
  const handleTpag = (tpag: number | undefined) => {
    setTpag(tpag);
  };
  const handleVenda = (venda: boolean | undefined) => {
    setvenda(venda);
  };
  const handleOperacao = (operacao: string | undefined) => {
    setOperacao(operacao);
  };
  const handleConfirmFinalizar = () => {
    setOpenConfirmFinalizar(false);
    formRef.current?.submitForm();

  };

  const handleCancelFinalizar = () => {
    setOpenConfirmFinalizar(false);
  };
  const handleConfirmDeleteItem = () => {
    setRows(prevRows => {
      const itemRemovido = prevRows.find(item => item.iditens === iditem);

      if (itemRemovido) {
        setRowsids(prev => [
          ...prev,
          { iditens: itemRemovido.iditens },
        ]);
      }
      return prevRows.filter(item => item.iditens !== iditem);
    });
    setOpenConfirmItem(false);
  };
  return (
    <>
      <TelaBloqueioSalvando
        open={isSaving}
        message={id === 'novo' ? 'Salvando entrada...' : 'Salvando alterações...'}
        progress={saveProgress}
      />
      <LayoutBaseDePaginaNfe
      barraDeFerramentas={
        <FerramentasDeDetalheVenda
          textoBotaoNovo='Nova Entrada'
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoImpressao={false}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={id !== 'novo'}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoSalvar={true}

          disableBotaoSalvar={statuss === false ? (isLoading || isSaving) : true }
          disableBotaoSalvarEFechar={statuss === false ? (isLoading || isSaving) : true}
          disableBotaoApagar={statuss === false ? isLoading: true }
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate('/entrada')}
          mostrarBotaoVoltarCarregando={isLoading}
          aoClicarEmNovo={() => navigate('/entrada/novo')}
          mostrarBotaoNovoCarregando={isLoading}
          aoClicarEmApagar={() => handleDelete()}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={tms === 'error' ? null : 900} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {msg}
          </Alert>
        </Snackbar>

        <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="error"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDelete}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este registro?
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirmItem} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="error"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDeleteItem}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDeleteItem}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este Item?
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirmFinalizar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button
                  color="inherit"
                  size="small"
                  autoFocus
                  onClick={handleConfirmFinalizar}
                >
                  Sim
                </Button>
                <Button
                  color="inherit"
                  size="small"
                  onClick={handleCancelFinalizar}
                >
                  Não
                </Button>
              </>
            }
          >
            Deseja realmente finalizar a venda?
          </Alert>
        </Snackbar>
        <Box margin={0.5} display="flex" flexDirection="column" component={Paper} variant="outlined">
          <Grid container direction="column" padding={1} spacing={1}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid container marginTop={1} item direction="row" spacing={1.5} >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={1.5}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <AutoCompleteParceiro
                      isExternalLoading={statuss === false ? isLoading : true}
                      cpfs={handlecpf}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                    <AutoCompleteOperacoes
                      isExternalLoading={statuss === false ? isLoading : true}
                      disabled={statuss === false ? isLoading : true}
                      faturamento={handleFaturamento}
                      tpag={handleTpag}
                      venda={handleVenda}
                      operacao={handleOperacao}
                      tipo={0}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={2} xl={3}>
                    <AutoCompletePlanoDeContas
                      isExternalLoading={statuss === false ? isLoading : true}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6} md={6} lg={2} xl={1.5}>
                    <VTextFieldData
                      fullWidth
                      size='small'
                      name='emissao'
                      label='Data de Emissão'
                      disabled={statuss === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1.3} xl={1.5}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='numero'
                      label='Numero'
                      disabled={isLoading}
                    />
                  </Grid>
                  {decimais === 4 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.3} xl={1.5}>
                      <VFieldMoney4
                        fullWidth
                        size='small'
                        name='vprod'
                        label='Total produtos'
                        disabled={true}
                      />
                    </Grid>
                  )}
                  {decimais === 2 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.3} xl={1.5}>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='vprod'
                        label='Total produtos'
                        disabled={true}
                      />
                    </Grid>
                  )}
                  {decimais === 2 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.4} xl={1.5}>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='desconto'
                        label='Desconto (R$)'
                        disabled={statuss === false ? isLoading : true}
                        calcular={handleDesconto}
                      />
                    </Grid>
                  )}

                  {decimais === 4 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.4} xl={1.5}>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='desconto'
                        label='Desconto (R$)'
                        disabled={statuss === false ? isLoading : true}
                        calcular={handleDesconto}
                      />
                    </Grid>
                  )}
                  {decimais === 4 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.33} xl={1.5}>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='descontopercentual'
                        label='Desconto (%)'
                        calcular={(valor) => handlePercentualDesconto(valor)}
                        disabled={statuss === false ? isLoading : true}
                        InputProps={{
                          endAdornment: '%',
                        }}
                      />
                    </Grid>
                  )}
                  {decimais === 2 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.33} xl={1.5}>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='descontopercentual'
                        label='Desconto (%)'
                        calcular={(valor) => handlePercentualDesconto(valor)}
                        disabled={statuss === false ? isLoading : true}
                        InputProps={{
                          endAdornment: '%',
                        }}
                      />
                    </Grid>
                  )}
                  {decimais === 4 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.33} xl={1.5}>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='acrescimo'
                        label='Acréscimo (R$)'
                        disabled={statuss === false ? isLoading : true}
                        calcular={handleAcrescimo}
                      />
                    </Grid>
                  )}
                  {decimais === 2 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.33} xl={1.5}>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='acrescimo'
                        label='Acréscimo (R$)'
                        disabled={statuss === false ? isLoading : true}
                        calcular={handleAcrescimo}
                      />
                    </Grid>
                  )}
                  {decimais === 4 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.33} xl={1.5}>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='acrescimopercentual'
                        label='Acrescimo (%)'
                        calcular={(valor) => handlePercentualAcrescimo(valor)}
                        disabled={statuss === false ? isLoading : true}
                        InputProps={{
                          endAdornment: '%',
                        }}
                      />
                    </Grid>
                  )}
                  {decimais === 2 && (
                    <Grid item xs={6} sm={6} md={2} lg={1.33} xl={1.5}>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='acrescimopercentual'
                        label='Acrescimo (%)'
                        calcular={(valor) => handlePercentualAcrescimo(valor)}
                        disabled={statuss === false ? isLoading : true}
                        InputProps={{
                          endAdornment: '%',
                        }}
                      />
                    </Grid>
                  )}
                  {decimais === 4 && (
                    <Grid item xs={6} sm={6} md={2} lg={2} xl={1.5}>
                      <VFieldMoneyNumber4dn
                        fullWidth
                        size='small'
                        name='total'
                        label='Total do Pedido'
                        disabled={true}
                      />
                    </Grid>
                  )}
                  {decimais === 2 && (
                    <Grid item xs={6} sm={2} md={2} lg={2} xl={1.5}>
                      <VFieldMoneyNumber2
                        fullWidth
                        size='small'
                        name='total'
                        label='Total do Pedido'
                        disabled={true}
                      />
                    </Grid>
                  )}

                </Grid>
              </Grid>
              <Grid item xs={12} ref={tabelaItensRef}>
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    width: '100%',
                    maxHeight: densidadeTabela.maxHeight,
                    overflow: 'auto',
                    backgroundColor: theme =>
                      theme.palette.mode === 'light'
                        ? alpha(theme.palette.grey[200], 0.55)
                        : theme.palette.background.default,

                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    p: 0,
                    scrollbarWidth: 'thin',
                    scrollbarColor: theme =>
                      theme.palette.mode === 'dark'
                        ? `${alpha(theme.palette.grey[400], 0.4)} transparent`
                        : `${alpha(theme.palette.grey[600], 0.35)} transparent`,

                    '&::-webkit-scrollbar': {
                      width: 8,
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: theme =>
                        theme.palette.mode === 'dark'
                          ? alpha(theme.palette.grey[500], 0.45)
                          : alpha(theme.palette.grey[600], 0.35),
                      borderRadius: 8,
                    },
                  }}
                >
                  <Table
                    size="small"
                    stickyHeader
                    sx={{
                      width: '100%',
                      borderCollapse: 'separate',
                      borderSpacing: 0,
                    }}
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          '& th': {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,

                            backgroundColor: theme =>
                              theme.palette.mode === 'light'
                                ? alpha(theme.palette.primary.main, 0.08)
                                : alpha(theme.palette.primary.main, 0.16),

                            color: 'text.secondary',
                            fontSize: `${densidadeTabela.headerFontSize}rem`,
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            letterSpacing: '0.04em',
                            border: 'none',
                            py: densidadeTabela.headerPy,
                          },
                        }}
                      >
                        <TableCell align="center">QTD</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell align="center">Ref</TableCell>
                        <TableCell align="center">UN</TableCell>
                        <TableCell align="right">Preço</TableCell>
                        <TableCell align="right">Total</TableCell>
                        <TableCell align="right" sx={{ pr: 2 }}>
                          <IconButton
                            size="small"
                            disabled={statuss === false ? isLoading : true}
                            onClick={() => {
                              setIditens('novo');
                              setOpen(true);
                            }}
                            sx={{
                              backgroundColor: 'action.hover',
                              color: 'primary.main',
                              padding: densidadeTabela.headerPy,
                              '&:hover': {
                                backgroundColor: 'action.selected',
                              },
                            }}
                          >
                            <AddShoppingCartIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.length === 0 ? (
                        <TableRow>
                          <TableCell
                            colSpan={6}
                            align="center"
                            sx={{
                              py: 6,
                              color: 'text.secondary',
                              fontStyle: 'italic',
                            }}
                          >
                            Nenhum item adicionado
                          </TableCell>
                        </TableRow>
                      ) : (
                        rows.map(row => (
                          <TableRow
                            key={row.iditens}
                            hover
                            sx={{
                              transition: 'all 0.15s ease',

                              '& td': {
                                backgroundColor: theme =>
                                  theme.palette.mode === 'light'
                                    ? alpha(theme.palette.common.white, 0.9)
                                    : alpha(theme.palette.background.paper, 0.85),

                                border: 'none',
                                py: densidadeTabela.rowPy,
                                fontSize: `${densidadeTabela.rowFontSize}rem`,
                              },

                              '&:hover td': {
                                backgroundColor: 'action.hover',
                              },
                              '& td:first-of-type': {
                                borderTopLeftRadius: 8,
                                borderBottomLeftRadius: 8,
                              },
                              '& td:last-of-type': {
                                borderTopRightRadius: 8,
                                borderBottomRightRadius: 8,
                              },
                            }}
                          >
                            <TableCell align="center">
                              {(row.qtde ?? 0).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                              })}
                            </TableCell>

                            <TableCell sx={{ fontWeight: 600 }}>
                              {row.descricao}
                            </TableCell>
                            <TableCell align="center">{row.referencia}</TableCell>
                            <TableCell align="center">{row.un}</TableCell>

                            <TableCell align="right">
                              {(row.preco ?? 0).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 4,
                              })}
                            </TableCell>

                            <TableCell
                              align="right"
                              sx={{ fontWeight: 700, color: 'success.main' }}
                            >
                              {(row.subtotal ?? 0).toLocaleString('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 4,
                              })}
                            </TableCell>
                            <TableCell align="right" sx={{ pr: 2 }}>
                              <IconButton
                                size="small"
                                color="primary"
                                disabled={statuss === false ? isLoading : true}
                                onClick={() => {
                                  setIditens(row.iditens);
                                  handleBuscarDados(row.iditens);
                                  setOpen(true);
                                }}
                                sx={{ mr: 0.5, padding: densidadeTabela.rowPy }}
                              >
                                <Icon fontSize="small">edit</Icon>
                              </IconButton>

                              <IconButton
                                size="small"
                                disabled={statuss === false ? isLoading : true}
                                sx={{
                                  color: 'text.secondary',
                                  padding: densidadeTabela.rowPy,
                                  '&:hover': {
                                    color: 'text.primary',
                                  },
                                }}
                                onClick={() => handleDeleteItem(row.iditens)}
                              >
                                <Icon fontSize="small">delete</Icon>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>


              </Grid>


            </Grid>
            <DialogEntrada
              decimais={decimais}
              open={open}
              onClose={() => setOpen(false)}
              onConfirm={handleConfirmDialog}
              itensIniciais={rows}
            />
            <DialogFaturamento
              id={id}
              value={guuid}
              decimais={decimais}
              iduser={iduser}
              dados={cabecalho}
              dadosItens={rows}
              open={openFaturamento}
              onClose={handleCloseFaturamento}
              status={statuss}
              operacao={operacao}
              iddeletados={rowsids}
            />
          </Grid>
        </Box>
      </VForm>
      </LayoutBaseDePaginaNfe>
    </>
  );
};